import React, {Component} from 'react'
import GroupsView from './groups/GroupsView'
import AdminReportView from './report/ReportView'
import {userIsAdmin, userIsGroupAdmin} from '../../constants'

export default class AdminPanel extends Component {

    constructor(props) {
        super(props)

        const admin = userIsAdmin(this.props.user)
        this.state = {
            showAdminReport: !admin,
            admin: admin,
            teamAdmin: userIsGroupAdmin(this.props.user)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.user && !prevProps.user) {
            this.setState({
                admin: userIsAdmin(this.props.user),
                teamAdmin: userIsGroupAdmin(this.props.user)
            })
        }
    }

    render() {
        //console.log('AdminPanel', this.props)

        return (
            <div className="create-form-container">
                <div className="create-form-header">
                    <div style={{display:'inline-block'}}>ADMIN PANEL</div>
                    <div className="align-right" style={{ display: 'inline-block', float: 'right'}}>
                        {this.state.admin && <button className="inline-block link no-underline" style={{color:'#ffffff', textAlign:'right'}} onClick={() => this.setState({showAdminReport: !this.state.showAdminReport})}>
                            {this.state.showAdminReport ? 'Manage maintenance agencies' : 'Admin reports' }
                        </button>}
                    </div>
                </div>
                {this.state.showAdminReport ?
                    <AdminReportView
                        tests={this.props.tests}
                        groups={this.props.groups}
                        dispatch={this.props.dispatch}
                        loading={this.props.loading}
                        report={this.props.report}
                        MDAYearly={this.props.MDAYearly}
                    /> :
                    <GroupsView groups={this.props.groups}
                                closeGroup={() => this.setState({selectedGroup: undefined})}
                                dispatch={this.props.dispatch}
                    />}

            </div>
        );
    }
}







// WEBPACK FOOTER //
// ./src/components/admin/AdminPanel.jsx